<script setup>
defineProps({ blok: Object })
</script>

<template>
  <FormQuestions :content="blok" />
</template>
